import { ModulesGuard } from './core/guards/modules.guard';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

//Routes
import { AUTH_ROUTES } from './shared/routes/auth-layout.routes';
import { CONTENT_ROUTES } from './shared/routes/content-layout.routes';

//Layouts
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { ContentLayoutComponent } from './layouts/content-layout/content-layout.component';
import { AuthGuardService } from './core/guards/auth-guard.service';
import { NoAuthGuardService } from './core/guards/no-auth-guard.service';
import { DashboardLayoutComponent } from './layouts/dashboard-layout/dashboard-layout.component';
import { NotFoundComponent } from './shared/components/not-found/not-found.component';
import { ComingSoonComponent } from './shared/components/coming-soon/coming-soon.component';
import { UnauthLayoutComponent } from './layouts/unauth-layout/unauth-layout.component';
import { PermissionGuard } from './core/guards/permission.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/auth/login',
    pathMatch: 'full'
  },
  {
    path: '',
    component: AuthLayoutComponent,
    canActivate: [NoAuthGuardService],
    children: AUTH_ROUTES
  },
  {
    path: 'menu',
    component: DashboardLayoutComponent,
    canActivate: [AuthGuardService],
    data: {
      breadcrumb: 'Dashboard'
    },
  },
  {
    path: '',
    component: ContentLayoutComponent,
    canActivate: [AuthGuardService, ModulesGuard],
    canActivateChild: [PermissionGuard],
    children: CONTENT_ROUTES,
  },
  {
    path: '',
    component: UnauthLayoutComponent,
    // canActivate: [ModulesGuard],
    children: [
      {
        data: { id_modulo: 6 },
        path: 'payment',
        loadChildren: './modules/payment/payment.module#PaymentModule'
      },
    ],
  },
  {
    path: '',
    component: UnauthLayoutComponent,
    // canActivate: [ModulesGuard],
    children: [
      {
        data: { id_modulo: 7 },
        path: 'rxsup',
        loadChildren: './modules/rxsup/rxsup.module#RxsupModule'
      },
    ],
  },
  {
    path: '',
    component: UnauthLayoutComponent,
    // canActivate: [ModulesGuard],
    children: [
      {
        data: { id_modulo: 8 },
        path: 'aprob',
        
        loadChildren: './modules/reception-advanced-doeq/aprob/aprob.module#AprobModule'
      },
    ],
  },
  {
    path: '',
    component: UnauthLayoutComponent,
    // canActivate: [ModulesGuard],
    children: [
      {
        data: { id_modulo: 89 },
        path: 'cvfa-unauth',        
        loadChildren: './modules/active-resume/unauth-active-resume/aprob.module#AprobModule'
      },
    ],
  },
  {
    path: 'coming-soon',
    component: ComingSoonComponent,
  },
  {
    path: '**',
    component: NotFoundComponent,
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts